import { IconButton, styled } from '@yuno/design-system-web'

export const IconButtonStyled = styled(IconButton)(
  ({ open, isTesting }: { open: boolean; isTesting: boolean }) => ({
    position: 'fixed',
    left: open ? '238px' : '56px',
    top: isTesting ? '52px' : '12px',
    zIndex: 1000000,

    '.drawer-menu-icon:hover': {
      transition: 'transform 0.3s ease',
      transform: 'scale(1.4)',
    },
  }),
)
